module.exports = __webpack_public_path__ + "0893fce542b367fa00bf510a44d25dc6.jpg";